import type { Ref } from 'vue';
import type { SpokenLanguage } from '~/help/languages';

type MissionCreatedCallback = () => void | Promise<void>;

export interface MissionPrefillData {
  step1?: Record<string, any>;
  step2?: Record<string, any>;
  /** Required languages carried over from the expert search filters (ticket #271). */
  languages?: SpokenLanguage[];
}

export interface PublishMissionModalOpenOptions {
  missionId?: string;
  step?: number;
  action?: 'clone';
  prefill?: MissionPrefillData;
}

const modalState = {
  isOpen: null as Ref<boolean> | null,
  onMissionCreatedCallback: null as MissionCreatedCallback | null,
  openOptions: null as Ref<PublishMissionModalOpenOptions | null> | null,
};

export const usePublishMissionModal = () => {
  if (!modalState.isOpen) {
    modalState.isOpen = ref(false);
  }
  if (!modalState.openOptions) {
    modalState.openOptions = ref(null);
  }

  const open = (options?: PublishMissionModalOpenOptions) => {
    modalState.openOptions!.value = options || null;
    modalState.isOpen!.value = true;
  };

  const close = () => {
    modalState.isOpen!.value = false;
  };

  const consumeOpenOptions = (): PublishMissionModalOpenOptions | null => {
    const options = modalState.openOptions!.value;
    modalState.openOptions!.value = null;
    return options;
  };

  const onMissionCreated = (callback: MissionCreatedCallback) => {
    modalState.onMissionCreatedCallback = callback;
  };

  const triggerMissionCreated = async () => {
    if (modalState.onMissionCreatedCallback) {
      await modalState.onMissionCreatedCallback();
    }
  };

  return {
    isOpen: modalState.isOpen!,
    open,
    close,
    consumeOpenOptions,
    onMissionCreated,
    triggerMissionCreated,
  };
};
